import React, { useCallback } from 'react'

import { classnames, Divider, Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function UsageTracker({
  downloadsUsed, downloadLimit, periodEndDate = null,
  canceledByAdmin = false, isDisabled = false, locale = 'en',
}) {
  const usagePercentage = downloadLimit > 0
    ? Math.min((downloadsUsed / downloadLimit) * 100, 100)
    : 0

  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  return (
    <div className={classnames('usage-tracker', isDisabled && 'usage-tracker--disabled')}>
      <div className="cgt-legacy-text-caption usage-tracker__header">
        {translate('subscription_management.active.usage.header')}
      </div>

      <Divider customClass="usage-tracker__divider" />

      <div className="usage-tracker__count-row">
        <span className="cgt-text-medium">
          {translate('subscription_management.active.usage.models_downloaded')}
        </span>
        <span className="cgt-text-medium cgt-text-medium--semi-bold">
          {downloadsUsed}/{downloadLimit}
        </span>
      </div>

      <div
        className="usage-tracker__progress-container"
        role="progressbar"
        aria-valuenow={downloadsUsed}
        aria-valuemin={0}
        aria-valuemax={downloadLimit}
        aria-label={`${downloadsUsed} of ${downloadLimit} models downloaded`}
      >
        <div
          className="usage-tracker__progress-fill"
          style={{ width: `${usagePercentage}%` }}
        />
      </div>

      {!canceledByAdmin && (
        <div className="usage-tracker__reset-row">
          <Icon svgComponent={InfoOutlined} size="small" color="dark" />
          <span className="cgt-legacy-text-tiny">
            {translate('subscription_management.active.usage.reset_date')}{' '}
            <strong>
              {periodEndDate
                ? translate('subscription_management.active.usage.resets_on', { date: periodEndDate })
                : translate('subscription_management.active.usage.no_reset_date')}
            </strong>
          </span>
        </div>
      )}

      <p
        className="cgt-legacy-text-tiny usage-tracker__description"
        // Translation HTML is sourced from local bundles and limited to trusted copy updates.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: translate('subscription_management.active.usage.description'),
        }}
      />
    </div>
  )
}

UsageTracker.propTypes = {
  downloadsUsed: number.isRequired,
  downloadLimit: number.isRequired,
  periodEndDate: string,
  canceledByAdmin: bool,
  isDisabled: bool,
  locale: string,
}

export default UsageTracker
